import { RootReducer } from 'store/store';
import { ProfessionalState } from './_types';
import { Organization } from '_types';

const proStateFromRoot = (state: RootReducer): ProfessionalState =>
    state.professional;

export const proAccountSelector = (state: RootReducer): Organization | null =>
    proStateFromRoot(state).organization;
